import { useEffect } from 'react';
import type { StepProps } from '../engine/context.ts';
import { TitleBlock } from '../ui/TitleBlock.tsx';
import { Confetti } from '../ui/bits.tsx';
import { Icon } from '../ui/Icon.tsx';
import { CORAL_DEEP, CREAM, GREEN_BG, GREEN_FG, GREEN_TEXT, MUTED, SAND } from '../ui/theme.ts';

/** Celebration icon + pop, confetti once on mount, strength / risk / next tiles. */
export function ArchetypeStep({ step, content, ctx }: StepProps) {
  const a = ctx.archetype;

  useEffect(() => {
    ctx.setCta({ label: content.cta ?? ctx.shared.ui?.next ?? 'Next', onPress: ctx.next });
    ctx.event('archetype_shown', { archetype: a.id });
  }, [step.id, a.id]);

  return (
    <>
      <TitleBlock label={content.label} title={a.name} subtitle={a.body} icon={a.icon} iconVariant="celebration" popIcon />

      <div style={{ position: 'relative' }}>
        <Confetti />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
        <div style={{ padding: 14, borderRadius: 20, background: GREEN_BG, display: 'flex', flexDirection: 'column', gap: 6 }}>
          <Icon name="sparkle" size={22} color={GREEN_FG} />
          <div style={{ fontWeight: 800, fontSize: 14 }}>{ctx.shared.ui?.strength ?? 'Your strength'}</div>
          <div style={{ fontSize: 13, color: GREEN_TEXT, fontWeight: 600 }}>{a.strength}</div>
        </div>
        <div style={{ padding: 14, borderRadius: 20, background: SAND, display: 'flex', flexDirection: 'column', gap: 6 }}>
          <Icon name="warning" size={22} color={CORAL_DEEP} />
          <div style={{ fontWeight: 800, fontSize: 14 }}>{ctx.shared.ui?.watchOut ?? 'What to watch out for'}</div>
          <div style={{ fontSize: 13, color: MUTED, fontWeight: 600 }}>{a.risk}</div>
        </div>
      </div>

      <div style={{ padding: '14px 16px', borderRadius: 20, background: CREAM, display: 'flex', gap: 10, alignItems: 'flex-start' }}>
        <Icon name="list-checks" size={22} color={CORAL_DEEP} style={{ flex: 'none' }} />
        <div>
          <div style={{ fontWeight: 800, fontSize: 14 }}>{ctx.shared.ui?.nextSteps ?? 'Next steps'}</div>
          <div style={{ fontSize: 13, color: MUTED, fontWeight: 600 }}>{a.next}</div>
        </div>
      </div>
    </>
  );
}
